import Vue, { CreateElement } from 'vue'
import { Component } from '@niknevis/vue-modules'

@Component
export class RenderTd extends Vue {
  __renderTd(
    h: CreateElement,
    col: any,
    grid: boolean,
    value = col.value,
    hideTitle = false
  ) {
    if (grid) {
      return h('div', {
        staticClass: 'q-table__grid-item-row'
      }, [
        !hideTitle
          ? h('div', { staticClass: 'q-table__grid-item-title' }, [col.label])
          : null,
        h('div', { staticClass: 'q-table__grid-item-value' }, [
          value
        ])
      ])
    }

    return h('td', {
      class: col.__tdClass(),
      style: col.__tdStyle()
    }, value)
  }
}
